module.exports = __webpack_public_path__ + "img/symbol_12.fceece4d.png";